export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_09.956a5442.jpg";